import { NgModule } from '@angular/core';
import { QueryService } from '@spartacus/core';
import { QueryService as CustomQueryService } from './utils/query.service';

@NgModule({
  providers: [
    {
      provide: QueryService,
      useExisting: CustomQueryService,
    },
  ],
})
export class CoreSpartacusModule {}
